import React, { useEffect, useRef } from "react"
import { StaticImage } from "gatsby-plugin-image"
import "lazysizes"
import "lazysizes/plugins/attrchange/ls.attrchange"
import PropTypes from "prop-types"
import { getFileType } from "../utils/helpers"

const StrapiMedia = ({
  image,
  className,
  width,
  height,
  isLazyLoad,
  ...props
}) => {
  const { url } = image?.data?.attributes ?? {}
  const videoRef = useRef()

  const mediaUI = {
    image: (
      <img
        className={`${isLazyLoad ? "lazyload" : ""} strapi-image ${className}`}
        alt={image.data.attributes.alternativeText || "redsoda"}
        width={width}
        height={height}
        {...(isLazyLoad
          ? { "data-src": image.data.attributes.url }
          : { src: image.data.attributes.url })}
        {...props}
      />
    ),
    video: (
      <video
        className={`strapi-video ${className}`}
        ref={videoRef}
        width={width}
        height={height}
        muted
        autoPlay
        loop
        playsInline
        {...props}
      >
        <source src={url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    ),
  }

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    const handleMouseEnter = () => {
      video.setAttribute("controls", "controls")
    }

    const handleMouseLeave = () => {
      video.removeAttribute("controls")
    }

    video.addEventListener("mouseenter", handleMouseEnter)
    video.addEventListener("mouseleave", handleMouseLeave)

    return () => {
      video.removeEventListener("mouseenter", handleMouseEnter)
      video.removeEventListener("mouseleave", handleMouseLeave)
    }
  }, [])

  if (!image.data) {
    return (
      <div className="flex flex-col items-center space-x-3 animate-pulse">
        <StaticImage
          width={300}
          src="../static/images/icon/redsoda-logo-light.svg"
          alt="icon/redsoda-logo-light"
          formats={["auto", "webp", "avif"]}
        />
        <div className="flex flex-row space-x-2 mt-10">
          <div
            style={{ backgroundColor: "#CE2D41" }}
            className="w-8 h-8 rounded-full animate-bounce"
          ></div>
          <div className="w-8 h-8 bg-black rounded-full animate-bounce-1"></div>
          <div
            style={{ backgroundColor: "#CE2D41" }}
            className="w-8 h-8 rounded-full animate-bounce-2"
          ></div>
          <div className="w-8 h-8 bg-black rounded-full animate-bounce-3"></div>
        </div>
      </div>
    )
  }

  return mediaUI[getFileType(url) || "image"]
}

StrapiMedia.defaultProps = {
  isLazyLoad: true,
  className: "",
}

StrapiMedia.propTypes = {
  image: PropTypes.object.isRequired,
  className: PropTypes.string,
  isLazyLoad: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default StrapiMedia
